import { AxiosResponse, CancelToken } from 'axios';

import { defaultBaseApi } from '~src/services/ApiController';
import logger from '~src/services/logger/LlsLogger';
import { Segment, SegmentType } from '~src/interfaces/segment.interface';

export const fetchSearchSegments = (
  value: string,
  cancelToken: CancelToken,
  types?: SegmentType[],
  includeDeactivated?: boolean,
): Promise<Segment[]> =>
  new Promise((res, rej) => {
    const valueNoSpaces = value.replace(/\s+/g, '');
    if (valueNoSpaces.length === 0) {
      return res([]);
    }
    defaultBaseApi
      .getSegments(
        {
          type: types,
          q: value,
          include_deactivated: includeDeactivated ? '1' : '0',
        },
        { cancelToken },
      )
      .then(({ data }: AxiosResponse<Segment[]>) => res(data))
      .catch((err: Error) => {
        logger.info('Error on segment request', {
          error: err,
          info: {
            componentStack: 'search.js',
          },
        });
        rej(err);
      });
  });
